import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  LoginReq,
  LoginRes,
  ResetPasswordReq,
  ResetPasswordRes,
  VerifyTokenReq,
  VerifyTokenRes,
  UpdatePasswordReq,
  UpdatePasswordRes,
  MyMerchantReq,
  MerchantData,
  MyMerchantRes,
  RegisterTokenReq,
  RegisterTokenRes,
  RegisterAccountReq,
  RegisterAccountRes,
  StaffLoginReq,
  LoginStaffRes,
  StaffPermissionReq,
  StaffPermissionRes,
  RefreshTokenReq,
  RefreshTokenRes,
} from './types'
//import { MerchantData } from 'Store/merchant/types'

export const loginAction = createAsyncAction('USER/LOGIN_REQ', 'USER/LOGIN_SUCCESS', 'USER/LOGIN_FAILURE')<
  LoginReq,
  LoginRes,
  Error
>()

export const staffLoginAction = createAsyncAction(
  'USER/STAFF_LOGIN_REQ',
  'USER/STAFF_LOGIN_SUCCESS',
  'USER/STAFF_LOGIN_FAILURE',
)<StaffLoginReq, LoginStaffRes, Error>()

export const resetPasswordAction = createAsyncAction(
  'USER/RESET_PASSWORD_REQ',
  'USER/RESET_PASSWORD_SUCCESS',
  'USER/RESET_PASSWORD_FAILURE',
)<ResetPasswordReq, ResetPasswordRes, Error>()

export const verifyTokenAction = createAsyncAction(
  'USER/VERIFY_TOKEN_REQ',
  'USER/VERIFY_TOKEN_SUCCESS',
  'USER/VERIFY_TOKEN_FAILURE',
)<VerifyTokenReq, VerifyTokenRes, Error>()

export const updatePasswordAction = createAsyncAction(
  'USER/UPDATE_PASSWORD_REQ',
  'USER/UPDATE_PASSWORD_SUCCESS',
  'USER/UPDATE_PASSWORD_FAILURE',
)<UpdatePasswordReq, UpdatePasswordRes, Error>()

export const getMyMerchantsAction = createAsyncAction(
  'USER/MY_MERCHANTS_REQ',
  'USER/MY_MERCHANTS_SUCCESS',
  'USER/MY_MERCHANTS_FAILURE',
)<MyMerchantReq, MyMerchantRes, Error>()

export const findRegisterTokenAction = createAsyncAction(
  'USER/FIND_REGISTER_TOKEN_REQ',
  'USER/FIND_REGISTER_TOKEN_SUCCESS',
  'USER/FIND_REGISTER_TOKEN_FAILURE',
)<RegisterTokenReq, RegisterTokenRes, Error>()

export const registerAccountAction = createAsyncAction(
  'USER/REGISTER_ACCOUNT_REQ',
  'USER/REGISTER_ACCOUNT_SUCCESS',
  'USER/REGISTER_ACCOUNT_FAILURE',
)<RegisterAccountReq, RegisterAccountRes, Error>()

export const getStaffPermissionAction = createAsyncAction(
  'USER/STAFF_PERMISSION_REQ',
  'USER/STAFF_PERMISSION_SUCCESS',
  'USER/STAFF_PERMISSION_FAILURE',
)<StaffPermissionReq, StaffPermissionRes, Error>()

export const refreshTokenAction = createAsyncAction(
  'USER/REFRESH_TOKEN_REQ',
  'USER/REFRESH_TOKEN_SUCCESS',
  'USER/REFRESH_TOKEN_FAILURE',
)<RefreshTokenReq, LoginRes, Error>()

export const clearEventAction = createStandardAction('USER/CLEAR_EVENT')<void>()

export const logoutAction = createStandardAction('USER/LOGOUT')<void>()

export const updateCurrentUserAction = createStandardAction('USER/UPDATE_ACCESSTOKEN')<{
  accessToken?: string
}>()

export const updateActiveMerchantAction = createStandardAction('USER/UPDATE_ACTIVE_MERCHANT')<{
  merchant: MerchantData
}>()

export const updateActiveMerchantLogoAction = createStandardAction('USER/UPDATE_ACTIVE_MERCHANT_LOGO')<{
  logo: string
}>()
